module.exports = __webpack_public_path__ + "img/menu-icon-tasks.248f786c.svg";